{
  "tabs": {
    "chat": "Chat",
    "reminders": "Podsjetnici",
    "calendar": "Kalendar",
    "settings": "Postavke"
  },
  "common": {
    "cancel": "Odustani",
    "save": "Spremi",
    "confirm": "Potvrdi",
    "delete": "Izbriši",
    "back": "Natrag",
    "close": "Zatvori",
    "edit": "Uredi",
    "search": "Pretraži",
    "all": "Sve",
    "loading": "Učitavanje...",
    "error": "Nešto je pošlo po zlu",
    "notFound": "Nije pronađeno",
    "tryAgain": "Pokušajte ponovno",
    "retry": "Ponovi",
    "undo": "Poništi",
    "pullToRefresh": "Povuci za osvježenje",
    "justNow": "upravo sada"
  },
  "auth": {
    "welcome": "Dobrodošli u FishMemory",
    "tagline": "Vaš WhatsApp asistent za podsjetnike, sada u vašem džepu.",
    "subtitle": "Vaš WhatsApp asistent za podsjetnike, sada u vašem džepu.",
    "phoneLabel": "Vaš WhatsApp broj",
    "phoneHint": "Poslat ćemo vam verifikacijski kod putem WhatsAppa",
    "invalidPhone": "Unesite valjani broj telefona",
    "continue": "Nastavi",
    "enterPhone": "Unesite svoj WhatsApp broj",
    "phonePlaceholder": "Broj telefona",
    "sendCode": "Pošalji kod",
    "verifyTitle": "Potvrdite svoj broj",
    "otpSentTo": "6-znamenkasti kod poslan je na {{phone}} putem WhatsAppa",
    "enterFullCode": "Unesite svih 6 znamenki",
    "invalidOtp": "Nevažeći kod. Pokušajte ponovno.",
    "otpFailed": "Slanje koda nije uspjelo. Pokušajte ponovno.",
    "otpResent": "Kod ponovno poslan",
    "resendIn": "Ponovno pošalji za {{seconds}}s",
    "resendCode": "Ponovno pošalji kod",
    "enterOtp": "Unesite kod poslan na vaš WhatsApp",
    "verify": "Potvrdi",
    "resend": "Ponovno pošalji kod",
    "wrongNumber": "Pogrešan broj?",
    "backToPhone": "Natrag na broj",
    "editPhone": "Uredi broj telefona",
    "error": "Greška",
    "setupTitle": "Postavimo stvari",
    "setupSubtitle": "Ove postavke uvijek možete promijeniti u Postavkama",
    "namePlaceholder": "Vaše ime",
    "letsGo": "Završi postavljanje",
    "skipForNow": "Preskoči za sada"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Upišite poruku...",
    "inputPlaceholder": "Upišite poruku...",
    "typing": "FishMemory piše...",
    "online": "Online",
    "connecting": "Povezivanje...",
    "reconnecting": "Ponovno povezivanje...",
    "offline": "Offline",
    "empty": "Započni razgovor",
    "emptyHint": "Kreiraj podsjetnike, provjeri raspored ili zatraži pomoć.",
    "emptyAction": "Pošalji primjer podsjetnika",
    "actions": "Radnje u chatu",
    "keep": "Zadrži poruke",
    "clearTitle": "Očisti chat",
    "clearConfirm": "Izbrisati sve poruke s ovog uređaja? Ovo se ne može poništiti.",
    "clear": "Očisti chat",
    "optionSelected": "Odabrano: {{label}}",
    "sendingSelection": "Šalje se...",
    "connectionLost": "Ponovno se povezuje..."
  },
  "reminders": {
    "title": "Moji podsjetnici",
    "active": "Aktivni",
    "today": "Danas",
    "thisWeek": "Ovaj tjedan",
    "history": "Povijest",
    "items": "stavke",
    "emptyTitle": "Još nema podsjetnika",
    "emptySubtitle": "Kreirajte jedan u chatu i pojavit će se ovdje.",
    "emptyAction": "Otvori chat",
    "filterActive": "Aktivni",
    "filterToday": "Danas",
    "filterWeek": "Ovaj tjedan",
    "filterHistory": "Povijest",
    "emptyState": "Još nema podsjetnika. Počnite razgovarati!",
    "swipeDone": "Gotovo",
    "swipeSnooze": "Odgodi",
    "swipeDelete": "Izbriši",
    "search": "Pretraži podsjetnike...",
    "upcoming": "Nadolazeći",
    "completed": "Završeni",
    "overdue": "Prošli rok",
    "tomorrow": "Sutra",
    "synced": "Sinkronizirano {{value}}",
    "swipeHint": "Prijeđite prstom po podsjetniku za više radnji",
    "noResults": "Nema podsjetnika koji odgovaraju pretraživanju",
    "noResultsHint": "Pokušajte s drugom ključnom riječi ili očistite pretraživanje",
    "deleteAllFailed": "Brisanje svih podsjetnika nije uspjelo"
  },
  "calendar": {
    "title": "Kalendar",
    "today": "Danas",
    "tomorrow": "Sutra",
    "completed": "dovršeno",
    "noEvents": "Nema zakazanih događaja",
    "noEventsSubtitle": "Odaberite datum za pregled podsjetnika i događaja u kalendaru.",
    "googleEvent": "Google Kalendar",
    "legendActive": "Aktivno",
    "legendRecurring": "Ponavljajuće",
    "legendDone": "Dovršeno",
    "legendGoogle": "Google",
    "previousMonth": "Prošli mjesec",
    "nextMonth": "Sljedeći mjesec",
    "previousYear": "Prošla godina",
    "nextYear": "Sljedeća godina",
    "goToToday": "Idi na danas",
    "all": "Sve",
    "active": "Aktivno",
    "done": "Dovršeno",
    "paused": "Pauzirano"
  },
  "settings": {
    "title": "Postavke",
    "profile": "Profil",
    "name": "Prikazano ime",
    "enterName": "Unesite ime",
    "language": "Jezik",
    "uiLanguage": "Jezik aplikacije",
    "uiLanguageHelp": "Mijenja jezik sučelja, oznake kalendara i smjer izgleda samo na ovom uređaju.",
    "serverLanguage": "Jezik chata",
    "serverLanguageHelp": "Mijenja jezik odgovora servera i poruka podsjetnika za vaš račun.",
    "timezone": "Vremenska zona",
    "currentTimezone": "Trenutna vremenska zona",
    "timezoneHelp": "Sva vremena podsjetnika prikazuju se prema ovoj vremenskoj zoni.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Spremi vremensku zonu",
    "timezoneSaved": "Vremenska zona ažurirana",
    "detect": "Otkrij",
    "detectFailed": "Nije moguće otkriti vremensku zonu",
    "autoDetect": "Automatski otkrij putem GPS-a",
    "notifications": "Obavijesti",
    "notificationsHelp": "Podsjetnici za praćenje kontroliraju ponovljene obavijesti nakon što je podsjetnik isporučen. Dozvole za obavijesti na razini uređaja i dalje se upravljaju u postavkama telefona.",
    "pushEnabled": "Push obavijesti",
    "autoDoneOnFire": "Automatski označi kao dovršeno kad se aktivira",
    "autoDoneOnFireDesc": "Kad je isključeno, podsjetnici ostaju aktivni dok ih ne označite kao dovršene.",
    "googleCalendar": "Google Kalendar",
    "google": "Google Kalendar",
    "googleConnected": "Povezano",
    "googleDisconnected": "Nije povezano",
    "googleConnectedHelp": "Novi podsjetnici mogu se automatski sinkronizirati s vašim kalendarom.",
    "googleDisconnectedHelp": "Povežite Google Kalendar za usklađivanje podsjetnika i događaja.",
    "googleConnectFailed": "Povezivanje Google Kalendara nije uspjelo",
    "connected": "Povezano",
    "disconnected": "Nije povezano",
    "connect": "Poveži",
    "disconnect": "Prekini vezu",
    "autoSync": "Automatska sinkronizacija novih podsjetnika",
    "autosync": "Automatska sinkronizacija novih podsjetnika",
    "subscription": "Pretplata",
    "trialUsed": "Probno: {{used}}/{{total}} iskorišteno",
    "trialStatus": "Probno dostupno",
    "activeStatus": "Aktivna pretplata",
    "expiredStatus": "Pretplata istekla",
    "unsubscribedStatus": "Nema pretplate",
    "about": "O aplikaciji",
    "version": "Verzija",
    "logout": "Odjava",
    "logoutTitle": "Odjava",
    "logoutConfirm": "Jeste li sigurni da se želite odjaviti?",
    "noName": "Ime nije postavljeno",
    "serverConnection": "Veza sa serverom",
    "serverUrl": "URL servera",
    "serverEdit": "Uredi",
    "saveReconnect": "Spremi i ponovno poveži",
    "resetDefault": "Vrati na zadano",
    "invalidServerUrlTitle": "Nevažeći URL servera",
    "invalidServerUrlMessage": "Unesite valjani http ili https URL servera, na primjer https://example.com",
    "uiLanguageChangeFailed": "Promjena jezika aplikacije nije uspjela. Pokušajte ponovno.",
    "serverLanguageChangeFailed": "Promjena jezika chata nije uspjela. Pokušajte ponovno.",
    "timezoneChangeFailed": "Promjena vremenske zone nije uspjela. Pokušajte ponovno.",
    "autoSyncChangeFailed": "Ažuriranje automatske sinkronizacije nije uspjelo. Pokušajte ponovno.",
    "nameChangeFailed": "Ažuriranje prikazanog imena nije uspjelo. Pokušajte ponovno.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Detalji podsjetnika",
    "editTime": "Uredi vrijeme",
    "rename": "Preimenuj",
    "snooze": "Odgodi",
    "snooze15": "Odgodi 15 minuta",
    "pause": "Pauziraj",
    "pauseReminder": "Pauziraj podsjetnik",
    "resume": "Nastavi",
    "resumeReminder": "Nastavi podsjetnik",
    "skip": "Preskoči sljedeći",
    "skipOccurrence": "Preskoči ovaj put",
    "syncGoogle": "Sinkroniziraj s Googleom",
    "delete": "Izbriši",
    "deleteTitle": "Izbriši podsjetnik",
    "deleteConfirm": "Ovaj podsjetnik će biti trajno izbrisan.",
    "deleteRecurringTitle": "Izbriši ponavljajući podsjetnik",
    "deleteRecurringMessage": "Želite li preskočiti ovaj put ili izbrisati cijelu seriju?",
    "deleteThisOccurrence": "Preskoči ovaj put",
    "deleteEntireSeries": "Izbriši cijelu seriju",
    "done": "Gotovo",
    "markDone": "Označi kao dovršeno",
    "undo": "Vrati",
    "undoPrompt": "Treba li vam ponovno aktivan? Vratite ga sada.",
    "recurring": "Ponavljajući",
    "nextRun": "Sljedeće izvršenje",
    "oneTime": "Jednokratni",
    "pending": "Na čekanju",
    "sent": "Poslano",
    "paused": "Pauzirano",
    "active": "Aktivno",
    "snoozed": "Odgoda",
    "localTime": "Prikazano u vašem lokalnom vremenu",
    "recurrence": "Ponavljanje",
    "created": "Kreirano",
    "tags": "Oznake",
    "fireCount": "Broj aktivacija",
    "actions": "Radnje",
    "none": "Nema",
    "snoozeFailed": "Odgoda podsjetnika nije uspjela",
    "pauseFailed": "Pauziranje podsjetnika nije uspjelo",
    "resumeFailed": "Nastavljanje podsjetnika nije uspjelo",
    "skipFailed": "Preskakanje podsjetnika nije uspjelo",
    "doneFailed": "Označavanje podsjetnika kao dovršenog nije uspjelo",
    "undoFailed": "Vraćanje statusa podsjetnika nije uspjelo",
    "deleteFailed": "Brisanje podsjetnika nije uspjelo",
    "rescheduleTitle": "Prebaci termin?",
    "rescheduleMsg": "Ovaj podsjetnik je prošao rok. Želite li ga prebaciti na novi termin?",
    "reschedule15": "Za 15 minuta",
    "reschedule60": "Za 1 sat",
    "keepOverdue": "Zadrži kao jest"
  },
  "onboarding": {
    "slide1Title": "Dobrodošli u FishMemory",
    "slide1Sub": "Vaš osobni asistent za podsjetnike — pokretan WhatsAppom i napravljen za vaš džep.",
    "slide2Title": "Samo razgovarajte prirodno",
    "slide2Sub": "Upišite podsjetnike kako ih mislite: \"Podsjeti me nazvati mamu sutra u 15h\" — mi ćemo se pobrinuti za ostalo.",
    "slide3Title": "Nikad ništa ne propustite",
    "slide3Sub": "Primajte pravovremene obavijesti, organizirajte s oznakama i budite u tijeku sa svime što vam je važno.",
    "getStarted": "Započni",
    "next": "Dalje",
    "firstReminderTitle": "Kreirajte svoj prvi podsjetnik!",
    "firstReminderHint": "Pokušajte upisati nešto poput:",
    "firstReminderExample": "Podsjeti me da pijem vodu sutra u 9 sati",
    "gotIt": "Razumijem!",
    "notifRationaleTitle": "Budite na vrijeme",
    "notifRationaleBody": "FishMemory treba obavijesti da vas podsjeti na vrijeme. Dobivat ćete upozorenja samo za podsjetnike koje kreirate.",
    "notifRationaleAllow": "Omogući obavijesti",
    "notifRationaleLater": "Možda kasnije",
    "swipeHint": "Prijeđite desno za brze radnje →",
    "calendarDragHint": "Povucite za proširenje ↕"
  }
}
